import OurHistorySection from "./AboutSection/OurHistorySection";
import WhoWeAreSection from "./AboutSection/WhoWeAreSection";

export default function About () {
    return (
        <div>
            <WhoWeAreSection />
            <OurHistorySection />
        </div>
    )
}